<template>
    <div class="row" v-if="current || isOverview">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <transition-group name="slide-fade">
                <div v-if="!isOverview" class="middle-bar-title" key="title-bar">Payment Options</div>

                <div class="payment-tabs" key="payment-tabs" v-if="!isOverview">
                    <!-- BEGIN LOOP -->

                    <div v-for="option in payment_options" class="fields selection thirds payment-tab-control ignore" :id="'payment-tab-'+(!isOverview ? option.payment_option_id : option.id)" :class="{ 'active checked': (!isOverview ? option.payment_option_id : option.id) == current.payment_option_id }">
                        <input type="radio" :id="'payment-option-'+(!isOverview ? option.payment_option_id : option.id)" name="paymentMethod" :value="option" v-model="current" :checked="(!isOverview ? option.payment_option_id : option.id) == current.payment_option_id" :disabled="isOverview"/>
                        <label :for="'payment-option-'+(!isOverview ? option.payment_option_id : option.id)">
                            <div class="checkbox horizontal" :class="{ hide: isOverview && (!isOverview ? option.payment_option_id : option.id) != current.payment_option_id }">
                            </div>

                            <div class="title" :class="{ hide: isOverview && (!isOverview ? option.payment_option_id : option.id) != current.payment_option_id }" v-html="option.name"></div>
                        </label>
                    </div>

                    <!-- END LOOP -->
                </div>

                <div class="box-layout-inner payment-methd-list" key="payment-method-list" :style="{ 'border-radius': (isOverview ? '10px' : null) }" v-if="$parent.basket.booking_items.length > 0 || current">

                    <div class="payment-mthods" v-if="!isOverview && current">

                        <div class="payment-method-list">

                            <transition-group name="list">

                                <div class="followed-block" key="desc" v-if="current != null && current.payment_option_id == 3">
									<span class="vertical" v-html="$parent.locale.text_payment_description_childcare_vouchers"></span>
								</div>
                                <div class="followed-block" key="desc" v-else-if="current != null && current.payment_option_id == 2">
									<span class="vertical" v-html="$parent.locale.text_payment_description_staged_payment"></span>
								</div>
                                <div class="followed-block" key="desc" v-else-if="current != null && current.payment_option_id == 1">
									<span class="vertical" v-html="$parent.locale.text_payment_description_single_payment"></span>
								</div>

                                <div class="payment-methods" v-if="(!isOverview && current.booking_changes.payment_plan.length > 0)" v-bind:key="2">

                                    <transition-group name="list">
                                        <div class="payment-list" v-for="(payment, id) in current.booking_changes.payment_plan" v-bind:key="id" :class="{ 'pay-today': (new Date(payment.payment_date)).isToday(), 'to-refund': payment.payment_amount < 0, 'no-border': current.booking_changes.payment_plan.length == id+1 || (current.booking_changes.payment_plan.length % 2 == 0 && current.booking_changes.payment_plan.length == id+2) }" v-if="!isOverview">
                                            <span v-html="shortDateString(payment.payment_date)"></span>
                                            <b>{{ $parent.currencyFormat(payment.payment_amount) }}</b>
                                        </div>
                                    </transition-group>
                                </div>

                                <div class="payment-methods" v-else-if="isOverview" v-bind:key="2">

                                    <transition-group name="list">
                                        <div class="payment-list" :class="'payment-state-'+payment.payment_state_id" v-for="(payment, id) in $parent.basket.payment_history" v-bind:key="'history'+id">
                                            <span v-html="shortDateString(payment.payment_date)"></span>
                                            <b>{{ $parent.currencyFormat(payment.payment_amount) }}</b>
                                        </div>
                                        <div class="payment-list" v-for="(payment, id) in $parent.basket.payment_plan" v-bind:key="id" :class="{ 'due-today': (new Date(payment.payment_date)).isToday() }">
                                            <span v-html="shortDateString(payment.payment_date)"></span>
                                            <b>{{ $parent.currencyFormat(payment.payment_amount) }}</b>
                                        </div>
                                    </transition-group>
                                </div>
                            </transition-group>
                        </div>
                    </div>
                    <div class="full-width dark-red" v-if="errors.length > 1 && !isOverview">
                        <h2>There were some problems</h2>
                        <ul>
                            <li v-for="error in errors" v-html="error"></li>
                        </ul>
                    </div>

                    <div class="box-layout-inner payments-financial-summary" :class="{ 'dark-blue': isOverview }" v-if="$parent.basket.booking_items.length > 0">

                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                            <div class="promo-code-box" v-if="isOverview">
                                <div class="fields input" v-if="$parent.basket.hasOwnProperty('promocode_applied') && $parent.basket.promocode_applied != null">
                                    <input type="text" id="promoCodeInput" :value="'Promo code applied: '+ $parent.basket.promocode_applied.toUpperCase()" name="promoCodeInput" readonly/>
                                </div>
                            </div>
                        </div>

                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 cart-totals">

                            <div class="basket-subtotal" v-if="((isOverview ? $parent.basket.fees.length : additional_fees.length) > 0 || (isOverview ? $parent.basket.discounts.length : additional_discounts.length) > 0)">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal">
                                    <span class="vertical">{{ $parent.locale.text_original_total }}: </span>
                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal">
                                    <b class="vertical">{{ $parent.currencyFormat($parent.basket.original_cost) }}</b>
                                </div>
                            </div>

                            <div class="fee-container" v-for="fee in (isOverview ? $parent.basket.fees : additional_fees)" v-if="fee.fee_amount != 0 && fee.discount_amount != 0">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                    <b>{{ (fee.description ? fee.description : fee.discount_blueprint.name) }}:</b>
                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                    <b>{{ $parent.currencyFormat((fee.fee_amount ? fee.fee_amount : fee.discount_amount)) }}</b>
                                </div>
                            </div>

                            <div class="discount-container" v-for="discount in (isOverview ? $parent.basket.discounts : additional_discounts)" v-if="discount.discount_amount != 0">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                    <b>{{ (discount.description ? discount.description : discount.discount_blueprint.name ) }}:</b>
                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                    <b>- {{ $parent.currencyFormat(discount.discount_amount) }}</b>
                                </div>
                            </div>

                            <div class="basket-subtotal" :class="{ 'large-single-total': basket.fees.length < 1 && basket.discounts.length < 1 }" v-if="$parent.basket.outstanding_balance != null">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal">
                                    <span class="vertical">{{ $parent.locale.text_total_cost }}: </span>
                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal">
                                    <b class="vertical">{{ $parent.currencyFormat(($parent.basket.total_payments_received > 0 ? $parent.basket.total_cost : total_payable)) }}</b>
                                </div>
                            </div>

                            <div class="discount-container" v-if="$parent.basket.total_payments_received > 0">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                    <b>{{ $parent.locale.text_total_payments_received }}:</b>
                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                    <b>- {{ $parent.currencyFormat($parent.basket.total_payments_received) }}</b>
                                </div>
                            </div>

                            <div class="basket-total" v-if="$parent.basket.total_payments_received > 0 && total_payable != undefined">
                                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal">
                                    <span class="vertical">{{ ( total_payable == $parent.basket.total_cost ? 'Booking Total' : (total_payable < 0 ? 'Refund Due' : 'Left to pay' ) ) }}: </span>
                                </div>
                                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal">
                                    <b class="vertical">{{ $parent.currencyFormat((isOverview ? basket.total_cost_minus_total_payments_received : current.booking_changes.total_cost_minus_total_payments_received)) }}</b>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="half-half blue" v-if="!isOverview && current">
                        <div class="left" id="confirm-payment-container">
                            <div class="fields selection" :class="{ 'has-error': errors.has('confirmPayment') }">
                                <input id="confirmPayment" v-validate="{ rules: { required: true } }" type="checkbox" name="confirmPayment"/>
                                <label for="confirmPayment">
                                    <div class="checkbox">
                                    </div>

                                    <div class="title terms-conditions">
                                        I have read and agree to the <a target="_blank" :href="$root.config.kings_terms_and_conditions_link">terms & conditions.</a>
                                    </div>
                                </label>
                                <p class="text-danger" v-show="errors.has('confirmPayment')">{{ errors.first('confirmPayment') }}</p>
                            </div>
                        </div>

                        <div class="right">
                            <input v-if="!loading" type="submit" class="cta-button red" :value="(total_payable > 0  || (basket.original_booking_id == null && total_payable >= 0) ? 'Pay '+ $parent.currencyFormat(current.booking_changes.amount_to_pay_today) + ' Today' : 'Confirm Changes')" @click="loading = true; progress()" />
                            <button class="cta-button red disabled" disabled v-else><i class="fa fa-spinner fa-pulse"></i> Please wait</button>
                        </div>
                    </div>

                </div>

                <div v-if="isOverview && (this.basket.hasOwnProperty('payment_history') && this.basket.hasOwnProperty('payment_plan'))" class="content-block-alone payment-plan-title" key="title-bar">
                    <div class="title">
                        <h1>Payment Overview</h1>
                    </div>
                </div>

                <div class="content-block-alone payment-plan-description" key="desc" v-if="basket != null && basket.payment_option_id == 3" v-html="basket.payment_option_readable + ' - ' + $parent.locale.text_payment_description_childcare_vouchers"></div>
                <div class="content-block-alone payment-plan-description" key="desc" v-else-if="basket != null && basket.payment_option_id == 2" v-html="basket.payment_option_readable + ' - ' + $parent.locale.text_payment_description_staged_payment"></div>
                <div class="content-block-alone payment-plan-description" key="desc" v-else-if="basket != null && basket.payment_option_id == 1" v-html="basket.payment_option_readable + ' - ' + $parent.locale.text_payment_description_single_payment"></div>

                <div class="box-layout-inner payment-plan" v-if="isOverview && (this.basket.hasOwnProperty('payment_history') && this.basket.hasOwnProperty('payment_plan'))" key="payment-method-list">
                    <div class="row payment-plan-headers">
                        <div class="col-xs-12 col" :class="{ 'col-sm-3 col-md-3 col-lg-3': !payments.methods_same, 'col-sm-4 col-md-4 col-lg-4': payments.methods_same }"><span>Date</span></div>
                        <div class="col-xs-12 col col-sm-3 col-md-3 col-lg-3" v-show="!payments.methods_same"><span>Method</span></div>
                        <div class="col-xs-12 col" :class="{ 'col-sm-3 col-md-3 col-lg-3': !payments.methods_same, 'col-sm-4 col-md-4 col-lg-4': payments.methods_same }"><span>Status</span></div>
                        <div class="col-xs-12 col" :class="{ 'col-sm-3 col-md-3 col-lg-3': !payments.methods_same, 'col-sm-4 col-md-4 col-lg-4': payments.methods_same }"><span>Amount</span></div>
                    </div>
                    <div class="row payment-plan-row" v-for="payment in payments.all" :class="(payment.payment_state_readable ? payment.payment_state_readable.toLowerCase() : 'future')">
                        <div class="col-xs-12 col" :class="{ 'col-sm-3 col-md-3 col-lg-3': !payments.methods_same, 'col-sm-4 col-md-4 col-lg-4': payments.methods_same }"><span v-html="(new Date(payment.payment_date)).toDateString()"></span></div>
                        <div class="col-xs-12 col col-sm-3 col-md-3 col-lg-3" v-show="!payments.methods_same"><span v-html="payment.payment_method_readable"></span></div>
                        <div class="col-xs-12 col" :class="{ 'col-sm-3 col-md-3 col-lg-3': !payments.methods_same, 'col-sm-4 col-md-4 col-lg-4': payments.methods_same }"><span v-html="payment.payment_state_readable || (payment.payment_amount < 0 ? $parent.locale.text_future_planned_refund : $parent.locale.text_future_planned_payment)"></span></div>
                        <div class="col-xs-12 col" :class="{ 'col-sm-3 col-md-3 col-lg-3': !payments.methods_same, 'col-sm-4 col-md-4 col-lg-4': payments.methods_same }"><span v-html="$parent.currencyFormat(payment.payment_amount, true)"></span></div>
                    </div>
                    <div class="row payment-plan-row empty" v-if="payments.all.length == 0">
                        <div class="col-xs-12 col col-sm-12 col-md-12 col-lg-12"><span>There are no completed/pending payments for this booking</span></div>
                    </div>
                </div>

            </transition-group>
        </div>

    </div>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-else>
        <p class="text-center"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
    </div>
</template>

<script>
    export default {
        props: ['basket'],
        data () {
            return {
                loading: false,

                payment_options: [],
                current: null,

                additional_fees: [],
                additional_discounts: [],
            }
        },
        computed: {
            total_payable: function () {
                if(this.isOverview)
                    return this.basket.total_cost_minus_total_payments_received;
                else
                    return this.current.booking_changes.total_cost_minus_total_payments_received;
            },
            payments: function () {
                if (this.basket.hasOwnProperty('payment_history') && this.basket.hasOwnProperty('payment_plan')) {
                    if (this.basket.payment_history.length > 0 || this.basket.payment_plan.length > 0) {
                        var all = (this.basket.payment_history != undefined ? this.basket.payment_history.concat(this.basket.payment_plan) : []);
                        return {
                            all: all.sort(function(a,b) {
								return a.payment_date.toDate().getTime() - b.payment_date.toDate().getTime();
								}),
                            methods_same: (all.length > 1 ? all.reduce(function (a, b) {
                                    return (a.payment_method_readable === b.payment_method_readable) ? a : false
                                }) != false : false),
                        }
                    } else {
                        return {
                            all: [],
                            methods_same: false
                        }
                    }
                } else {
                    return {
                        all: [],
                        methods_same: false
                    }
                }
            },
            isOverview: function () {
                return this.$parent.isOverview == true;
            }
        },
        watch: {
            current: function () {
                this.feesAndDiscounts();
            },
            '$route' (to) {
                this.update();
            },
            '$parent.basket': {
                handler: function () {

                    //If cancelled we need to force the payments to rerender
                    //if (this.$parent.basket.booking_state_id == 5) {
                      if (this.$parent.basket.hasOwnProperty('payment_history') && this.$parent.basket.hasOwnProperty('payment_plan')) {
                          if (this.$parent.basket.payment_history.length > 0 || this.$parent.basket.payment_plan.length > 0) {
                              var all = (this.$parent.basket.payment_history != undefined ? this.$parent.basket.payment_history.concat(this.$parent.basket.payment_plan) : []);

							  //Sort the array
							  all.sort(function(a,b) {return a.payment_date.toDate().getTime() - b.payment_date.toDate().getTime(); });

							  //Send methods_same back
							  methods_same: (all.length > 1 ? all.reduce(function (a, b) {
                                          return (a.payment_method_readable === b.payment_method_readable) ? a : false
                                      }) != false : false);

							  //Send back
                              this.payments.all = all;

                          } else {
                              return {
                                  all: [],
                                  methods_same: false
                              }
                              this.payments.all = all;
                          }
                      }
                    //}

                    this.payment_options.forEach(option => {
                        if(this.isOverview && option.payment_option_id == this.$parent.basket.payment_option_id)
                            this.current = option;
                        this.feesAndDiscounts();
                    })

                    this.$forceUpdate();
                },
                deep: true
            }
        },
        methods: {
            update: function () {
                /** Retrieving all available payment options from the api **/
                var bookingId = (this.$route.params.hasOwnProperty('bookingId') ? this.$route.params.bookingId : this.$parent.basket.booking_id)
                if(!this.isOverview)
                    axios.get('/camp-booking/bookings/' + bookingId + '/payment-options')
                        .then(response => {
                            this.payment_options = response.data.data;
                            this.payment_options.forEach(option => {
                                if(option.payment_option_id == 1)
                                    this.current = option;
                            })
                            this.feesAndDiscounts();
                        })

            },
            feesAndDiscounts: function () {
                this.additional_fees = [];
                this.additional_discounts = [];
                if(!this.isOverview) {
                    Object.keys(this.current.booking_changes.booking_fees).forEach(id => {
                        let fee = this.current.booking_changes.booking_fees[id];
                        this.additional_fees.push(fee);
                    })
                    Object.keys(this.current.booking_changes.booking_discounts).forEach(id => {
                        let discount = this.current.booking_changes.booking_discounts[id];
                        this.additional_discounts.push(discount);
                    })
                } else {
                    Object.keys(this.$parent.basket.fees).forEach(id => {
                        let fee = this.$parent.basket.fees[id];
                        this.additional_fees.push(fee);
                    })
                    Object.keys(this.$parent.basket.discounts).forEach(id => {
                        let discount = this.$parent.basket.discounts[id];
                        this.additional_discounts.push(discount);
                    })
                }
            },
            progress: function () {

                var check = true;
                this.$validator.validateAll().then(result => {
                    if(!result) {
                        this.$validator.validate('confirmPayment');
                        check = false;
                        return false;
                    }
                });

                /**
                 * Checking the booking for any errors before continuing
                 **/
                axios.get('/camp-booking/bookings/' + this.$parent.basket.booking_id + '/complete/check-for-errors?stage=confirmation')
                    .then(response => {
                        var errors = [];
                        response.data.data.forEach(collection => {
                            Object.keys(collection).map(key => {
                                return collection[key];
                            }).forEach(section => {
                                switch (typeof section) {
                                    case 'string':
                                        errors.push(section);
                                        break;
                                    case 'object':
                                        Object.keys(section).map(key => {
                                            return section[key];
                                        }).forEach(error => errors.push(error));
                                        break;
                                }
                            })
                        })

                        if (errors.length || !check) {
                            if(errors.length) {
                                this.$root.alert(errors, 'danger', false);
                                //Redirecting back to basket to fix errors
                                this.$router.push({ name: 'cart.basket' });
                            }
                            this.loading = false;
                            return false
                        }

                        setTimeout(() => {

                            this.loading = true;

                            //Determining whether the booking is about to be cancelled by checking if all the booking items are in cancelled state (4)
                            var cancelled = true;
                            this.$parent.basket.booking_items.forEach(participant => {
                                participant.items.forEach(booking_item => {
                                    if (booking_item.booking_item_state_id != 4)
                                        cancelled = false;
                                })
                            })

                            var booking_id = null;
                            axios.get('/camp-booking/users/' + this.$root.auth.user_id + '/basket')
                                .then(response => {
                                    var response = response.data.data;
                                    if (response.origional_booking_id != null && cancelled) {
                                        booking_id = response.origional_booking_id;
                                    } else {
                                        booking_id = response.booking_id;
                                    }
                                    axios.put('/camp-booking/bookings/' + this.$parent.basket.booking_id + '/complete', {
                                        payment_option_id: this.current.payment_option_id,
                                        payment_fail_url: this.$root.config.base_domain + "/#/checkout/payment/?payment_failure=true&booking_id=" + response.booking_id,
                                        finish_url: this.$root.config.base_domain + "/#/account/bookings/" + booking_id + "?thankyou=1",
                                        send_confirmation_email: this.$root.config.send_confirmation_email,
                                        force_payment_test_mode: this.$root.config.force_payment_test_mode
                                    }).then(response => {
                                        if (response.data.data.debug) {

                                        } else if (response.data.data.booking_complete || response.data.data.booking_cancelled) {
                                            window.location = response.data.data.url;
                                        }
                                        this.loading = false;
                                    }).catch(error => {
                                        this.loading = false;
                                    });
                                })
                        }, 1500);
                    });
            },
            shortDateString: function (dateString) {
                var date = dateString.toDate();

                if(date.isToday())
                    return '<b>Today</b>';

                return date.getDate().nth()+' '+date.getStrMonth('short')+' '+date.getFullYear();
            },
        },
        created () {
            this.update();
        }
    }
</script>



// WEBPACK FOOTER //
// PaymentOptions.vue?1936079b